export default __webpack_public_path__ + "static/benifitImage4-7107b702337cb3e70f63eb3ef39ad775.png";